import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { InstitutionalPageIcon, EternalAccessIcon, SealedEnvelopeIcon, DeviceSilhouettesIcon } from './ui/ArchivalIcons';
export function DigitalArchiveSpecs() {
  return <div className="bg-elevated border-t border-border-default" data-id="element-170">
      <FadeIn data-id="element-171">
        <div className="p-8 md:p-10" data-id="element-172">
          {/* Section header with gold rules */}
          <div className="flex items-center gap-4 mb-10" data-id="element-173">
            <div className="h-px bg-accent-primary/40 flex-grow" data-id="element-174" />
            <span className="font-ui text-xs font-semibold tracking-widest uppercase text-accent-soft" data-id="element-175">
              The Digital Archive
            </span>
            <div className="h-px bg-accent-primary/40 flex-grow" data-id="element-176" />
          </div>

          {/* 3-column specs grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6 mb-10" data-id="element-177">
            {/* Institutional Grade */}
            <div className="flex flex-col items-center text-center" data-id="element-178">
              <InstitutionalPageIcon className="text-accent-primary mb-4" size={32} data-id="element-179" />
              <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-primary mb-1" data-id="element-180">
                Institutional Grade
              </p>
              <p className="font-body text-xs text-text-muted" data-id="element-181">
                Museum-quality editorial formatting
              </p>
            </div>

            {/* Eternal Access */}
            <div className="flex flex-col items-center text-center" data-id="element-182">
              <EternalAccessIcon className="text-accent-primary mb-4" size={32} data-id="element-183" />
              <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-primary mb-1" data-id="element-184">
                Eternal Access
              </p>
              <p className="font-body text-xs text-text-muted" data-id="element-185">
                Download once, yours permanently
              </p>
            </div>

            {/* Instant Delivery */}
            <div className="flex flex-col items-center text-center" data-id="element-186">
              <SealedEnvelopeIcon className="text-accent-primary mb-4" size={32} data-id="element-187" />
              <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-primary mb-1" data-id="element-188">
                Instant Delivery
              </p>
              <p className="font-body text-xs text-text-muted" data-id="element-189">
                Sealed and sent to your inbox
              </p>
            </div>
          </div>

          {/* Device compatibility row */}
          <div className="flex flex-col items-center pt-6 border-t border-border-default" data-id="element-190">
            <DeviceSilhouettesIcon className="text-text-secondary mb-3" size={96} data-id="element-191" />
            <p className="font-ui text-xs font-semibold tracking-widest uppercase text-text-secondary" data-id="element-192">
              Compatible With All Devices
            </p>
          </div>
        </div>
      </FadeIn>
    </div>;
}